export const isBlogBackendConfigured = Boolean(process.env.REACT_APP_CONVEX_URL);

const ADMIN_KEY_STORAGE_KEY = process.env.REACT_APP_BLOG_ADMIN_KEY;

export const normalizeTags = (tagsText) =>
  tagsText
    .split(",")
    .map((tag) => tag.trim())
    .filter(Boolean);

export const normalizeBlogPayload = (payload) => ({
  title: payload.title.trim(),
  excerpt: payload.excerpt.trim(),
  content: payload.content.trim(),
  readTime: payload.readTime.trim() || "5 min read",
  tags: normalizeTags(payload.tags || ""),
  image: (payload.image || "").trim(),
});

export const getStoredAdminKey = () => {
  if (typeof window === "undefined") return "";
  return sessionStorage.getItem(ADMIN_KEY_STORAGE_KEY) || "";
};

export const setStoredAdminKey = (value) => {
  if (typeof window === "undefined") return;
  if (!value) {
    sessionStorage.removeItem(ADMIN_KEY_STORAGE_KEY);
    return;
  }
  sessionStorage.setItem(ADMIN_KEY_STORAGE_KEY, value.trim());
};

export const clearStoredAdminKey = () => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(ADMIN_KEY_STORAGE_KEY);
};

export const hasStoredAdminKey = () => Boolean(getStoredAdminKey());
